import { render, staticRenderFns } from "./BroadcastDraft.vue?vue&type=template&id=e2cfe7d4&"
import script from "./BroadcastDraft.vue?vue&type=script&lang=js&"
export * from "./BroadcastDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports